import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ItemFileRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("itemfile");
